<script setup lang="ts">
import type { ICampaignMedia } from './campaign.types';

const props = defineProps<{
  items: ICampaignMedia[];
  pendingDeleteId: string | null;
  reordering: boolean;
}>();

const emit = defineEmits<{
  'move-up': [id: string];
  'move-down': [id: string];
  remove: [media: ICampaignMedia];
}>();

function isFirst(id: string): boolean {
  return props.items[0]?.id === id;
}
function isLast(id: string): boolean {
  return props.items[props.items.length - 1]?.id === id;
}
</script>

<template>
  <div class="cgg">
    <div v-for="media in items" :key="media.id" class="cgg__item">
      <img :src="media.imageUrl" class="cgg__img" alt="" />
      <div class="cgg__overlay">
        <button
          class="cgg__icon-btn"
          :disabled="reordering || isFirst(media.id)"
          title="Monter"
          @click="emit('move-up', media.id)"
        >
          <i class="pi pi-arrow-up" />
        </button>
        <button
          class="cgg__icon-btn"
          :disabled="reordering || isLast(media.id)"
          title="Descendre"
          @click="emit('move-down', media.id)"
        >
          <i class="pi pi-arrow-down" />
        </button>
        <button
          class="cgg__icon-btn cgg__icon-btn--danger"
          :disabled="pendingDeleteId === media.id"
          title="Supprimer"
          @click="emit('remove', media)"
        >
          <i
            v-if="pendingDeleteId === media.id"
            class="pi pi-spin pi-spinner"
          />
          <i v-else class="pi pi-trash" />
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cgg {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.875rem;
}
.cgg__item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid var(--nxt-outline-variant);
  background: var(--nxt-surface-low);
}
.cgg__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.cgg__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 0.375rem;
  padding: 0.5rem;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.55) 0%,
    rgba(0, 0, 0, 0) 60%
  );
  opacity: 0;
  transition: opacity 0.15s ease;
}
.cgg__item:hover .cgg__overlay,
.cgg__item:focus-within .cgg__overlay {
  opacity: 1;
}
.cgg__icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  color: #0b1320;
  font-size: 0.75rem;
  cursor: pointer;
  flex-shrink: 0;
}
.cgg__icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.cgg__icon-btn--danger {
  color: var(--nxt-error);
}
</style>
